import { useMemo } from 'react';
import { useIsDemo } from '@/hooks/common/useIsDemo';
import { useSelectedOrgId } from '@/hooks/common/useSelectedOrgId';
import { PERSONAL_ORG_ID, VAULT_TREES } from '@/mockData';
import type { VaultFolderNode } from '@/types/vault.types';

const emptyFolder: VaultFolderNode = { id: '', name: '', children: [] };

export function useDemoVaultData() {
  const isDemo = useIsDemo();
  const selectedOrgId = useSelectedOrgId();
  const activeTrees = VAULT_TREES[selectedOrgId] ?? VAULT_TREES[PERSONAL_ORG_ID];

  const dealFilesMap = useMemo(
    () => (isDemo ? activeTrees.dealFilesMap : {}),
    [activeTrees.dealFilesMap, isDemo],
  );
  const dropboxRoot = useMemo(
    () => (isDemo ? activeTrees.dropbox : emptyFolder),
    [activeTrees.dropbox, isDemo],
  );
  const equaliqRoot = useMemo(
    () => (isDemo ? activeTrees.equaliq : emptyFolder),
    [activeTrees.equaliq, isDemo],
  );
  const gdriveRoot = useMemo(
    () => (isDemo ? activeTrees.gdrive : emptyFolder),
    [activeTrees.gdrive, isDemo],
  );
  const mailItems = useMemo(
    () => (isDemo ? activeTrees.mailItems : []),
    [activeTrees.mailItems, isDemo],
  );
  const meetingNotes = useMemo(
    () => (isDemo ? activeTrees.meetingNotes : []),
    [activeTrees.meetingNotes, isDemo],
  );
  const messages = useMemo(
    () => (isDemo ? activeTrees.messages : []),
    [activeTrees.messages, isDemo],
  );

  return {
    dealFilesMap,
    dropboxRoot,
    equaliqRoot,
    gdriveRoot,
    mailItems,
    meetingNotes,
    messages,
  };
}
